// extracted by mini-css-extract-plugin
var _1 = "sponsor-module_dialog_J2KPy";
var _2 = "sponsor-module_numberDisplayArea__600m";
var _3 = "sponsor-module_numberLabel_FpmSF";
var _4 = "sponsor-module_numbersDrop_rDDAn";
var _5 = "sponsor-module_sponsorOption_IbxbE";
var _6 = "sponsor-module_sponsorWrap_JdjL0";
export { _1 as "dialog", _2 as "numberDisplayArea", _3 as "numberLabel", _4 as "numbersDrop", _5 as "sponsorOption", _6 as "sponsorWrap" }
